import { render, staticRenderFns } from "./CardDossie.vue?vue&type=template&id=623fdbdc"
import script from "./CardDossie.vue?vue&type=script&lang=js"
export * from "./CardDossie.vue?vue&type=script&lang=js"
import style0 from "./CardDossie.vue?vue&type=style&index=0&id=623fdbdc&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('623fdbdc')) {
      api.createRecord('623fdbdc', component.options)
    } else {
      api.reload('623fdbdc', component.options)
    }
    module.hot.accept("./CardDossie.vue?vue&type=template&id=623fdbdc", function () {
      api.rerender('623fdbdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OnboardingDetailPerson/components/CardDossie.vue"
export default component.exports